import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { AsideComponent } from './aside/aside.component';
import { FooterComponent } from './footer/footer.component';
import { LoadingComponent } from './loading/loading.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NotcontentComponent } from './notcontent/notcontent.component';
import { SidebarComponent } from './sidebar/sidebar.component';

import { PagehbuttonsComponent } from './pagehbuttons/pagehbuttons.component';
import { PageheaderComponent } from './pageheader/pageheader.component';
import { PageinfoComponent } from './pageinfo/pageinfo.component';

import { PipesModule } from '../../../pipes/pipes.module';
import { CedulaComponent } from './cedula/cedula.component';


@NgModule({
	declarations: [
		AsideComponent,
		FooterComponent,
		LoadingComponent,
		NavbarComponent,
		NotcontentComponent,
		SidebarComponent,
		PagehbuttonsComponent,
		PageheaderComponent,
		PageinfoComponent,
		CedulaComponent,
	],
	imports: [
		CommonModule,
		RouterModule,
		PipesModule,
		NgxSkeletonLoaderModule.forRoot({ animation: 'pulse', loadingText: 'This item is actually loading...' }),
	],
	exports: [
		AsideComponent,
		FooterComponent,
		LoadingComponent,
		NavbarComponent,
		NotcontentComponent,
		SidebarComponent,
		PagehbuttonsComponent,
		PageheaderComponent,
		PageinfoComponent
	]
})

export class ComponentsModule { }
